import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import pdfMake from "pdfmake/build/pdfmake";
import _ from 'underscore';
import {formateaRut} from 'App/Helpers/Genericos'

const styles = theme => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center"
  },
  textField: {
    margin: theme.spacing.unit,
  },

});

const ax = axios.create();

const ReCaptchaComponent = (props) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    executeRecaptcha('verificaDte').then(t => {
      props.setToken(t);
      if (!_.isEmpty(props.data)) {
        var win = window.open('', '_blank');
        win.document.write("Cargando...")
        ax.post("/api/verificar/" + props.data.tipo, props.data)
          .then(response => {
            win.document.body.innerHTML = "";
            win.document.body.style.padding = 0;
            win.document.body.style.margin = 0;
            win.document.body.style.overflow = "hidden";
            var doc = pdfMake.createPdf(response.data.PDFMake)
            var callback = function (url) { win.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>") }
            doc.getDataUrl(callback, doc);
          })
          .catch(e => { win.close(); setTimeout(() => /*alert(e.response.data.Mensaje)*/{}, 0) });
      }
    }).catch(e => console.log(e))
  }, [props.data])

  return null;
}

function Verifica(props) {
  const { classes } = props;
  const [tipo, setTipo] = useState(39);
  const [rut, setRut] = useState("");
  const [token, setToken] = useState(null)
  const [data, setData] = useState({});

  useEffect(()=>{
    return(()=>{
      setData(null);
    })
  },[])

  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LcN578UAAAAAHBIgB66Q67AJhUhTG2vZW7hGQtn">
      <ReCaptchaComponent setToken={setToken} data={data} />
      <Grid container spacing={24}>
        <Grid item sm={12}>
          <Typography style={{ textAlign: "center" }} variant="h4" gutterBottom>Verifique Documento Electrónico</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            justify="center"
            alignItems="center">
            <Grid item sm={4}>
              {token ?
                <Paper className={classes.paper}>
                  <form onSubmit={
                    e => {
                      setData({
                        rut: e.target[0].value.split("-")[0].replace(/\./g, ""),
                        folio: e.target[1].value,
                        emision: e.target[2].value,
                        tipo: e.target[3].value,
                        monto: e.target[4].value,
                        captcha: e.target[5].value
                      })
                      e.preventDefault();
                    }
                  } className={classes.container} noValidate>
                    <TextField
                      label="RUT Emisor"
                      name="RUT"
                      fullWidth
                      value={rut}
                      onChange={e => setRut(formateaRut(e.target.value,true))}
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    /><br />
                    <TextField
                      label="Folio"
                      name="Folio"
                      fullWidth
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    /><br />
                    <TextField
                      label="Fecha de Emision"
                      type="date"
                      fullWidth
                      defaultValue={moment().format("YYYY-MM-DD")}
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      select
                      label="Tipo de Documento"
                      fullWidth
                      value={tipo}
                      onChange={e => setTipo(e.target.value)}
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      {[{ value: 39, label: "Boleta Electrónica" }, { value: 41, label: "Boleta no Afecta o Exenta Electrónica" }].map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField><br />
                    <TextField
                      label="Monto"
                      name="Monto"
                      fullWidth
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    /><br />
                    <input type="hidden" value={token} name="captcha" />
                    <Button type="submit" variant="contained" color="primary" className={classes.button}>
                      Verificar
      </Button>
                  </form>
                  <br />

                </Paper> :
                <Paper className={classes.paper}>
                  <CircularProgress className={classes.progress} />
                </Paper>
              }
            </Grid></Grid>

        </Grid>
      </Grid>
    </GoogleReCaptchaProvider>
  )
}

Verifica.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Verifica);